import { gsap } from 'gsap';
import { Draggable } from 'gsap/Draggable';
import { InertiaPlugin } from 'gsap/InertiaPlugin';

gsap.registerPlugin( Draggable, InertiaPlugin);

import { debounce as _debounce } from 'underscore';

export default class{

    constructor( options ) {
        this.defaults = {
        	$el: false,
        	min_dist_between: 40
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'module-submenu-pages';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;
		this.$window 		= 	$(window);

		if ( this.$el.length > 0 ){
			this.init();
		}
    }

    init(){

    	//console.log( 'init module subpages ' );

    	this.$constrain 	=   this.$el.parents( '.wrap.inner' );
 		this.$name 	    	= 	this.$constrain.find( '.name' );
 		this.$menu 			= 	this.$el.find( '.menu' );
 		this.width 			=	this.$menu.width();

 		this.addEvents( true );

    	this.onResize();
	}

	//---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		if ( b ){
			this.r = _debounce( ()=>{ this.onResize() }, 17 );
			this.$window.on( 'resize', this.r );
		}
		else{
			if ( this.r ){
				this.r.cancel();
				this.$window.off( 'resize', this.r );
			}
		}
		this.addDraggable( b )
	}

	addDraggable( b ){
		if ( b ){
			// set draggable
			Draggable.create( this.$menu, {
			    type:"x",
			    bounds: this.$el,
			    // THIS NEED INIERTIA PLUGIN!!!!!!!!!
			    inertia: true     
			});			
		}
		else{
			let draggable = this.getDraggable();
			if ( draggable ){
				draggable.kill();
			}
		}
	}
	onResize(){

		let w = this.$constrain.width(), available = w - this.$name.width() - this.options.min_dist_between, draggable = this.getDraggable();
		this.$el.width( available );

		if ( available < this.width ){
			this.$el.addClass( 'draggable-active' );
			gsap.set( this.$menu, { 'padding-right': 60 } );

			if ( draggable ){
				draggable.enable();
			}
			
		}
		else{
			this.$el.removeClass( 'draggable-active' );
			gsap.set( this.$menu, { 'x': 0, 'padding-right': 0 } );

			if ( draggable ){
				draggable.disable();
			}
		}

		if ( draggable ){
			draggable.update(true);
		}
	}

	getDraggable(){
		return Draggable.get( this.$menu );
	}


    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
		if ( this.$el.length > 0 ){
    		this.addEvents( false );
    	}
    }

}
